<template>
  <div class="uk-container">
    <h3>Enter your card info</h3>
    <p>We will let you know 15 days in advance when we are ready and we are going to charge.</p>
    <div>
      <div class="uk-card uk-card-secondary uk-card-hover uk-card-body uk-light">
        <p>Payment processing is PCI Compliant and your data is protected and processed by Stripe</p>
        <div id="payment-form" class="uk-form">
          <div class="form-row uk-margin">
            <!-- <label for="card-element">Credit or debit card</label> -->
            <div id="card-element">
              <!-- A Stripe Element will be inserted here. -->
            </div>

            <!-- Used to display form errors. -->
            <div v-if="error" class="uk-margin">
              <p class="uk-text-danger">Error while adding card: {{error}}</p>
            </div>
            <div id="card-errors" role="alert"></div>
          </div>

          <div v-if="cardAdded">
            <a
              class="uk-button uk-button-default uk-button-large"
              href="/tracking"
            >Track Your Containers Now</a>
          </div>
          <div v-else>
            <div v-if="loading" uk-spinner></div>
            <div v-else>
              <button
                @click="submitPayment"
                class="uk-button uk-button-primary uk-margin-right"
                id="card-button"
              >Add Credit Card</button>
              <button
                @click="skipPayment"
                class="uk-button uk-button-text"
                id="card-button"
              >Add credit card later</button>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { loadStripe } from '@stripe/stripe-js';
import PaymentIntent from '@/gql/user/payment.gql';
import OnboardPaymentCompleteMutation from '@/gql/user/onboardPaymentComplete.gql';

type User = {
  paymentIntentClientSecret: string;
};

export default defineComponent({
  name: 'Payments',
  data() {
    return {
      Stripe: undefined,
      user: {} as User,
      error: undefined as string,
      elements: undefined,
      loading: false,
      cardAdded: false,
    };
  },
  created() {
    let stripeKey;
    console.log('node env is');
    console.log(process.env.NODE_ENV);
    if (process.env.NODE_ENV === 'production') {
      stripeKey = 'pk_live_e5ueVSG17wCjfk5txqHOYy1W00kXJc4hoq';
    } else {
      stripeKey = 'pk_test_dM0RoCzk2BxbariwAaViSVaW00aF42jkK4';
    }

    const stripe = loadStripe(stripeKey);
    stripe.then((Stripe) => {
      this.Stripe = Stripe;
      const elements = Stripe.elements();
      this.elements = elements;
      const cardElement = elements.create('card');

      cardElement.mount('#card-element');
    });
  },
  methods: {
    skipPayment() {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: OnboardPaymentCompleteMutation,
          variables: {
            paymentMethod: '',
          },
        })
        .then((data) => {
          vm.loading = false;
          vm.cardAdded = true;
          vm.$emit('refreshContainers');
          // this.$router.push('/tracking');
        })
        .catch((error) => {
          vm.loading = false;
          vm.error = error.message;
        });
    },
    submitPayment() {
      const vm = (this as any);

      const cardholderName = document.getElementById('cardholder-name');
      const cardButton = document.getElementById('card-button');
      const clientSecret = vm.user.paymentIntentClientSecret;
      const cardElement = vm.elements.getElement('card');

      vm.loading = true;
      vm.Stripe.confirmCardSetup(clientSecret, {
        payment_method: {
          card: cardElement,
          billing_details: {
            name: 'Test User',
          },
        },
      }).then((result) => {
        if (result.error) {
          // Display error.message in your UI.

          console.error(`Stripe error ${result.error}`);
          vm.error = result.error.message;
          vm.loading = false;
        } else {
          vm.error = undefined;
          const paymentMethodRes = result.setupIntent.payment_method;
          vm.$apollo
            .mutate({
              mutation: OnboardPaymentCompleteMutation,
              variables: {
                paymentMethod: paymentMethodRes,
              },
            })
            .then((data) => {
              vm.loading = false;
              vm.cardAdded = true;
            })
            .catch((error) => {
              vm.loading = false;
              vm.error = error.message;
            });
          // The setup has succeeded. Display a success message.
        }
        // });
      });
    },
  },
  apollo: {
    user: {
      query: PaymentIntent,
    },
  },
});
</script>>

<style>
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
